import {Component, input, output} from '@angular/core';

import {SharedModule} from '../../../../../shared/shared.module';
import {DeclinaisonPlatData} from './declinaison-plat-data';

@Component({
  selector: 'yo-declinaison-plat',
  templateUrl: './declinaison-plat.component.html',
  styleUrls: ['../declinaison-produit-dialog-edit.component.scss'],
  standalone: true,
  imports: [
    SharedModule
  ]
})
export class DeclinaisonPlatComponent {

  data = input.required<DeclinaisonPlatData>();

  changeCompteComptable = output<number>();
  changeTaxe = output<number>();
  changeFamilleFacturation = output<number>();
  changeUniteDeMesure = output<number>();
  changeRatioUniteTechnique = output<string>();
  changeInverseRatioUniteTechnique = output<string>();
  changeTacheFabrication = output<number>();
  changeRegimes = output<(string | number)[]>();
  changeDlc = output<number>();
  changeRatioVolume = output<number>();
  changePrixDeVente = output<number>();
}
